import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FeatureFlagsApi } from "apis/FeatureFlagsApi";
import { SettingsApi } from "apis/SettingsApi";
import { StoresApi } from "apis/StoresApi";
import { FrontEndSetting } from "models/daoModels/settings/FrontEndSettings";
import { FeatureFlagView } from "models/dbModels/featureFlags/FeatureFlag";

export const getGlobalStores = createAsyncThunk("globalSlice/getGlobalStores", async () => {
    const response = await StoresApi.Search({});
    return response.data;
});

export const getFeatureFlags = createAsyncThunk("globalSlice/getFeatureFlags", async () => {
    const response = await FeatureFlagsApi.FeatureFlagsSearch();
    return response.data;
});



export const GetStoreGroupSetting = createAsyncThunk("globalSlice/GetStoreGroupSetting", async (key: string) => {
    const response = await SettingsApi.GetStoreGroupSetting(key);
    return response.data;
});

export const SetStoreGroupSetting = createAsyncThunk("globalSlice/SetStoreGroupSetting", async (payload: FrontEndSetting) => {
    const response = await SettingsApi.SetStoreGroupSetting(payload);
    return response.data;
});

export const GetUserSetting = createAsyncThunk("globalSlice/GetUserSetting", async (key: string) => {
    const response = await SettingsApi.GetStoreGroupSetting(key);
    return response.data;
});

export const SetUserSetting = createAsyncThunk("globalSlice/SetUserSetting", async (payload: FrontEndSetting) => {
    const response = await SettingsApi.SetStoreGroupSetting(payload);
    return response.data;
});


export interface ManagedCatalogueSetting {
    nextShow?: number;
}



export interface GlobalState {
    storeGroupId: number;
    storeName: string;
    darkMode: boolean;
    stores: any[];
    loadedFlags: boolean;
    featureFlags: FeatureFlagView[];

    managedCatalogue: ManagedCatalogueSetting;
    numStockConflicts: number;
}

const initialState : GlobalState = {
    storeGroupId: 0,
    storeName: "",
    darkMode: false,
    stores: [],
    featureFlags: [],
    loadedFlags: false,

    managedCatalogue: {
        nextShow: undefined,
    },

    numStockConflicts: 0,
}

const globalSlice = createSlice({
    name: "globalSlice",
    initialState: {
        ...initialState,
    },
    reducers: {
        updateStoreGroupId: (state, action) => {
            return {
                ...state,
                storeGroupId: action.payload,
            };
        },
        updateStoreGroupField: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value,
            };
        },
        clearStore: state => {} // We handle the actual clearing of the state in store.ts, this is just so we can have an action to call with a type we can listen for (loginSlice/clearStore) to initiate the clearing of the store
    },
    extraReducers: (builder) => {
        builder.addCase(getGlobalStores.fulfilled, (state, action) => {
            state.stores = action.payload.data;
        });

        builder.addCase(getFeatureFlags.fulfilled, (state, action) => {
            state.featureFlags = action.payload.data;
            state.loadedFlags = true;
        });
    }
});

export const { updateStoreGroupId, updateStoreGroupField, clearStore } = globalSlice.actions;

export default globalSlice.reducer;
